export default () => {
  window.addEventListener('load', () => {
    const swatchImages = document.querySelectorAll('.variable-item-image');
    if (!swatchImages.length) return;
  
    swatchImages.forEach(img => {
      img.src = img.src.replace('-50x50', '');
      img.width = 150;
      img.height = 150;
    });
  });
};
  